export default __webpack_public_path__ + "static/workflow-72fcc9bb33063a8c08ed1458ceaac93d.webp";